exports = module.exports = require("../../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}._3Nu_WgehOjZ90LmATW2x7d{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;background-color:#f3fff5;margin-top:1rem;margin-left:-1.5rem;margin-right:-1.5rem;margin-bottom:1rem;padding:1rem 1.5rem}._3Nu_WgehOjZ90LmATW2x7d .ico{margin-right:1rem}\n", ""]);

// exports
exports.locals = {
	"confirmedDeliveryContainer": "_3Nu_WgehOjZ90LmATW2x7d"
};